import { render, staticRenderFns } from "./dataset.vue?vue&type=template&id=0efefc2c&scoped=true"
import script from "./dataset.vue?vue&type=script&lang=js"
export * from "./dataset.vue?vue&type=script&lang=js"
import style0 from "./dataset.vue?vue&type=style&index=0&id=0efefc2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efefc2c",
  null
  
)

export default component.exports